// @flow

import * as React from 'react';

import { useSearchParams } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import {
  SegmentedControl,
  SegmentedControlItem,
} from '@gandi/ui/segmentedcontrol';

import styles from './DiscountSwitch.scss';

export function DiscountSwitch(): React.MixedElement {
  const { __ } = useTranslator();

  const [searchParams, setSearchParams] = useSearchParams();

  const withDiscount =
    !searchParams.has('discount') || searchParams.get('discount') === '1';

  return (
    <Base flex flexCol flexAlignItemsCenter>
      <SegmentedControl
        className={styles.switch}
        legend={__('Already a customer?')}
        name="discount"
        onValueChange={value => {
          setSearchParams(prev => {
            prev.set('discount', value);
            return prev;
          });
        }}
        value={withDiscount ? '1' : '0'}
      >
        <SegmentedControlItem value="1">
          {__('New customer')}
        </SegmentedControlItem>
        <SegmentedControlItem value="0">
          {__('Existing customer')}
        </SegmentedControlItem>
      </SegmentedControl>
      <Base color="light" margin="none" size="small" tagName="p">
        {withDiscount &&
          __('Welcome Offer reserved for New Hosting Customers.')}{' '}
        {__('Prices indicated for a one-year subscription.')}
      </Base>
    </Base>
  );
}
